import React, { Component } from "react";
import Infinite from "react-infinite";
import { withContentRect } from "react-measure";
import PropTypes from "prop-types";
import classNames from "classnames";

import CurationListItem from "curation/components/CurationListItem";
import StoryMenu from "dashboard/components/StoryMenu";
import Spinner from "components/library/Spinner";
import NoResults from "components/library/NoResults";

import styles from "./CurationList.css";

const MeasuredStory = withContentRect("client")(
  ({ measureRef, story, key, showPublishedDatetime }) => (
    <div ref={measureRef} key={key}>
      <CurationListItem
        curation={story}
        showPublishedDatetime={showPublishedDatetime}
      />
    </div>
  )
);

export default class CurationList extends Component {
  constructor(props) {
    super(props);

    this._handleInfiniteLoad = this._handleInfiniteLoad.bind(this);
    this.safeSetState = this._safeSetState.bind(this);

    this.state = {
      infiniteLoading: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.stories) {
      this.setState({
        // Because children haven't been measured yet, set height initially to an approximate value: 80px
        elementHeights: nextProps.stories.reduce(
          (accum, story) => ({ ...accum, [story.id]: 80 }),
          {}
        ),
        edgeOffset: 200,
      });
    }
  }

  componentWillUnmount() {
    this.safeSetState = () => {};
  }

  _updateSize(id, height) {
    this.setState({
      elementHeights: {
        ...this.state.elementHeights,
        [id]: height,
      },
    });
  }

  _safeSetState(state) {
    this.setState(state);
  }

  _handleInfiniteLoad() {
    this.setState({ infiniteLoading: true });
    // It's possible that this promise could resolve after unmount, if the user clicks away while another page is loading.
    this.props
      .next()
      .catch(() => this.safeSetState({ edgeOffset: undefined }))
      .then(() => this.safeSetState({ infiniteLoading: false }));
  }

  render() {
    const { stories } = this.props;

    if (this.props.isLoadingInitialList) {
      return (
        <div className={classNames(styles.noStories, this.props.className)}>
          <Spinner />
        </div>
      );
    }

    if (!stories.length) {
      return (
        <div className={classNames(styles.noStories, this.props.className)}>
          <NoResults message="No deep dives" />
        </div>
      );
    }

    if (this.state.elementHeights) {
      return (
        <div className={classNames(styles.root, this.props.className)}>
          <Infinite
            useWindowAsScrollContainer
            elementHeight={Object.values(this.state.elementHeights)}
            infiniteLoadBeginEdgeOffset={this.state.edgeOffset}
            loadingSpinnerDelegate={
              <div className={styles.spinnerContainer}>
                <Spinner />
              </div>
            }
            onInfiniteLoad={this._handleInfiniteLoad}
            isInfiniteLoading={this.state.infiniteLoading}
          >
            {stories.map(story => {
              return (
                <MeasuredStory
                  key={story.id}
                  story={story}
                  showPublishedDatetime={this.props.showPublishedDatetime}
                  onResize={contentRect => {
                    this._updateSize(story.id, contentRect.client.height);
                  }}
                />
              );
            })}
          </Infinite>
          <StoryMenu />
        </div>
      );
    } else {
      return null;
    }
  }
}

CurationList.propTypes = {
  stories: PropTypes.array,
  next: PropTypes.func,
  isLoadingInitialList: PropTypes.bool,
  className: PropTypes.string,
  showPublishedDatetime: PropTypes.bool,
};
